import * as React from "react";
import { Box, Text } from "@/components/ui/primitives";
import { BoxProps } from "@/lib/styling";

type BadgeVariant = "default" | "secondary" | "destructive" | "outline" | "success";

export interface BadgeProps extends BoxProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string; // Compatibility
}

function Badge({ variant = "default", children, className, ...props }: BadgeProps) {
  const getVariantStyles = () => {
    switch (variant) {
      case "success":
        return {
          backgroundColor: "successBackground",
          textColor: "success",
          borderColor: "success",
        } as const;
        case "secondary":
          return {
            backgroundColor: "muted",
            textColor: "text",
            borderColor: "border",
          } as const;
        case "destructive":
          return {
            backgroundColor: "destructive",
            textColor: "destructiveForeground",
            borderColor: "destructive",
          } as const;
        case "outline":
          return {
            backgroundColor: "transparent",
            textColor: "text",
            borderColor: "border",
          } as const;
        case "default":
        default:
          return {
            backgroundColor: "primary",
            textColor: "white",
            borderColor: "primary",
          } as const;
    }
  };

  const variantStyles = getVariantStyles();

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      borderRadius="full"
      paddingHorizontal="s"
      paddingVertical="xs"
      backgroundColor={variantStyles.backgroundColor}
      borderWidth={1}
      borderColor={variantStyles.borderColor}
      {...props}
    >
      <Text
        variant="caption"
        fontSize={12} // text-xs
        color={variantStyles.textColor}
      >
        {children}
      </Text>
    </Box>
  );
}

export { Badge };
